export default function RecommendationCategoryDirective() {
  return {
    template: require('./recommendation-category.html'),
    scope: {
      auditId: '=',
      recommendationCategory: '=',
      auditIsActive: '=',
      canEdit: '=',
      canDelete: '=',
    },
    controller: 'RecommendationCategoryController',
    controllerAs: 'recommendationCategoryVM',
    bindToController: true,
    replace: true
  };
}
